import { addInspirationAllToCart, exportInspirationShoppingListPdf } from './inspiration-api';

export const inspirationEventsMethods = {
    clearAllInspirationsFilters() {
        if (this.pendingFiltersCountTimer) {
            window.clearTimeout(this.pendingFiltersCountTimer);
            this.pendingFiltersCountTimer = null;
        }

        this.state.sort = 'newest';
        this.updateSortUi('newest');
        this.clearAppliedListingFilters();
    },

    onRootClick(event) {
        const inspirationOpenTrigger = event.target.closest(
            '[data-inspiration-open]'
        );

        if (inspirationOpenTrigger) {
            event.preventDefault();
            event.stopPropagation();

            const card = inspirationOpenTrigger.closest(
                '[js-inspiration-card]'
            );
            const termId = Number(card?.dataset?.termId || 0);

            if (termId > 0) {
                this.filtersSidebar?.close();
                this.openInspirationSidebar(termId);
            }

            return;
        }

        const card = event.target.closest('[js-inspiration-card]');

        if (card && this.root.contains(card)) {
            event.preventDefault();

            const termId = Number(card?.dataset?.termId || 0);

            if (termId > 0) {
                this.filtersSidebar?.close();
                this.openInspirationSidebar(termId);
            }

            return;
        }

        const filtersOpenTrigger = event.target.closest(
            '[data-listing-filters-open]'
        );

        if (filtersOpenTrigger) {
            event.preventDefault();

            if (!this.ensureFiltersSidebar()) {
                return;
            }

            this.syncPendingFiltersFromState();
            this.filtersSidebar.open();

            if (!this.filterCountsLoaded) {
                this.loadFilterTermCounts();
            }

            this.schedulePendingFiltersCountPreview();
            this.refreshFilterCollapseUi();
            return;
        }

        const filtersApplyTrigger = event.target.closest(
            '[data-listing-filters-apply]'
        );

        if (filtersApplyTrigger) {
            event.preventDefault();
            this.state.sort = this.getActiveSortFromMarkup(
                this.filtersSidebar?.content
            );
            this.state.filters = this.cloneFilters(this.pendingFilters);
            this.state.page = 1;
            this.filtersSidebar?.close();
            this.fetchAndRender({ pushUrl: this.getListingUrl() });
            return;
        }

        const filtersClearTrigger = event.target.closest(
            '[data-listing-filters-clear]'
        );

        if (filtersClearTrigger) {
            event.preventDefault();
            event.stopPropagation();
            this.clearAllInspirationsFilters();
            return;
        }

        const activeFilterRemoveTrigger = event.target.closest(
            '[data-listing-active-filter-remove]'
        );

        if (activeFilterRemoveTrigger) {
            event.preventDefault();

            const filterKey = activeFilterRemoveTrigger.dataset.filterKey || '';
            const filterValue =
                activeFilterRemoveTrigger.dataset.filterValue || '';

            if (!filterKey || !filterValue) {
                return;
            }

            if (filterKey === 'sort') {
                this.state.sort = 'popular';
                this.state.page = 1;
                this.updateSortUi('popular');
                this.syncPendingFiltersFromState();
                this.fetchAndRender({ pushUrl: this.getListingUrl() });
                return;
            }

            const nextFilters = this.cloneFilters(this.state.filters);
            const currentValue = nextFilters[filterKey];

            if (Array.isArray(currentValue)) {
                const nextValues = currentValue.filter(
                    value => value !== filterValue
                );

                if (nextValues.length > 0) {
                    nextFilters[filterKey] = nextValues;
                } else {
                    delete nextFilters[filterKey];
                }
            } else if (currentValue === filterValue) {
                delete nextFilters[filterKey];
            }

            this.state.filters = nextFilters;
            this.state.page = 1;
            this.syncPendingFiltersFromState();
            this.fetchAndRender({ pushUrl: this.getListingUrl() });
            return;
        }

        const filterMoreTrigger = event.target.closest(
            '[data-listing-filter-more]'
        );

        if (filterMoreTrigger) {
            event.preventDefault();
            this.expandFilterCollapseGroup(
                filterMoreTrigger.closest('[data-listing-filter-collapsible]')
            );
            return;
        }

        const filterToggle = event.target.closest(
            '[data-listing-filter-toggle]'
        );

        if (filterToggle) {
            event.preventDefault();

            const node = filterToggle.closest(
                '[data-listing-filter-group], [data-listing-filter-node]'
            );
            const content = node?.querySelector(
                ':scope > [data-listing-filter-children]'
            );
            const icon = filterToggle.querySelector('i');
            const isExpanded =
                filterToggle.getAttribute('aria-expanded') === 'true';

            if (content) {
                content.classList.toggle('hidden', isExpanded);
            }

            filterToggle.setAttribute(
                'aria-expanded',
                isExpanded ? 'false' : 'true'
            );
            icon?.classList.toggle('rotate-180', !isExpanded);

            if (!isExpanded) {
                this.refreshFilterCollapseUi();
            }

            return;
        }

        const filterSelect = event.target.closest(
            '[data-listing-filter-select]'
        );

        if (filterSelect) {
            event.preventDefault();

            const taxonomy = filterSelect.dataset.taxonomy || '';
            const slug = filterSelect.dataset.termSlug || '';

            if (!taxonomy || !slug) {
                return;
            }

            const isDesktopFilter = Boolean(
                filterSelect.closest('[data-listing-desktop-filters]')
            );

            if (isDesktopFilter) {
                const nextFilters = this.cloneFilters(this.state.filters);
                const currentValues = new Set(
                    Array.isArray(nextFilters[taxonomy])
                        ? nextFilters[taxonomy]
                        : nextFilters[taxonomy]
                          ? [nextFilters[taxonomy]]
                          : []
                );

                if (currentValues.has(slug)) {
                    currentValues.delete(slug);
                } else {
                    currentValues.add(slug);
                }

                const nextValues = Array.from(currentValues);

                if (nextValues.length > 0) {
                    nextFilters[taxonomy] = nextValues;
                } else {
                    delete nextFilters[taxonomy];
                }

                this.state.filters = nextFilters;
                this.state.page = 1;
                this.syncPendingFiltersFromState();
                this.updatePendingFilterSelectionUi();
                this.fetchAndRender({ pushUrl: this.getListingUrl() });
                return;
            }

            const usesBranchSelection =
                this.usesHierarchicalFilterSelection(taxonomy);
            const node = filterSelect.closest('[data-listing-filter-node]');

            if (usesBranchSelection && !node) {
                return;
            }

            const selectedSlugs = new Set(this.pendingFilters[taxonomy] || []);
            const isSelected = this.isSlugCoveredByPendingSelection(
                taxonomy,
                slug
            );
            const nodeSlugs = node ? this.getFilterNodeSlugs(node) : [slug];
            const descendantsMap =
                this.bootstrap.termDescendants?.[taxonomy] || {};

            if (isSelected) {
                if (usesBranchSelection) {
                    nodeSlugs.forEach(item => selectedSlugs.delete(item));

                    Array.from(selectedSlugs).forEach(selectedSlug => {
                        const branch = descendantsMap[selectedSlug] || [];

                        if (branch.includes(slug)) {
                            selectedSlugs.delete(selectedSlug);
                        }
                    });
                } else {
                    selectedSlugs.delete(slug);
                }
            } else if (usesBranchSelection) {
                nodeSlugs.forEach(item => selectedSlugs.add(item));
            } else {
                selectedSlugs.add(slug);
            }

            this.pendingFilters[taxonomy] = this.sortFilterValuesByDomOrder(
                taxonomy,
                Array.from(selectedSlugs)
            );

            this.updatePendingFilterSelectionUi();
            this.schedulePendingFiltersCountPreview();
            return;
        }

        const desktopFilterToggle = event.target.closest(
            '[data-listing-desktop-filter-toggle]'
        );

        if (desktopFilterToggle) {
            event.preventDefault();
            this.toggleDesktopFilterMenu(desktopFilterToggle);
            return;
        }

        const sortToggle = event.target.closest('[data-listing-sort-toggle]');

        if (sortToggle) {
            event.preventDefault();
            this.toggleSortMenu();
            return;
        }

        const sortOption = event.target.closest('[data-listing-sort-option]');

        if (sortOption) {
            event.preventDefault();

            const nextSort = sortOption.dataset.sortValue || 'popular';
            const isSidebarSortOption = Boolean(
                this.filtersSidebar?.content?.contains(sortOption)
            );

            if (isSidebarSortOption) {
                this.updateSortUi(nextSort, {
                    syncState: false,
                    scope: 'sidebar',
                });
                this.schedulePendingFiltersCountPreview();
                return;
            }

            if (nextSort !== this.state.sort) {
                this.applyListingSort(nextSort, {
                    fetch: true,
                    pushUrl: true,
                    closeSidebar: false,
                });
            } else {
                this.updateSortUi(nextSort);
            }

            this.closeSortMenu();
            return;
        }

        const loadMoreTrigger =
            event.target.closest('[data-listing-load-more] button') ||
            event.target.closest('[data-listing-load-more]');

        if (loadMoreTrigger) {
            event.preventDefault();

            const maxPages = Number(
                this.resultsPagination?.dataset.maxPages || 1
            );
            const currentPage = Number(
                this.resultsPagination?.dataset.page || this.state.page || 1
            );

            if (currentPage >= maxPages) {
                return;
            }

            this.state.page = currentPage + 1;
            this.fetchAndRender({ appendResults: true, showLoader: true });
        }
    },

    onDocumentClick(event) {
        const filtersClearTrigger = event.target.closest(
            '[data-listing-filters-clear]'
        );

        if (filtersClearTrigger) {
            event.preventDefault();
            event.stopPropagation();
            this.clearAllInspirationsFilters();
            return;
        }

        const exportPdfButton = event.target.closest(
            '[data-inspiration-export-pdf]'
        );

        if (exportPdfButton) {
            event.preventDefault();
            event.stopPropagation();

            const termId = Number(
                exportPdfButton.dataset.termId ||
                    this.activeInspirationTermId ||
                    0
            );

            if (termId > 0) {
                exportInspirationShoppingListPdf(this, termId);
            }

            return;
        }

        const addAllButton = event.target.closest(
            '[data-inspiration-add-all-to-cart]'
        );

        if (addAllButton) {
            event.preventDefault();
            event.stopPropagation();

            if (
                addAllButton.disabled ||
                addAllButton.getAttribute('aria-disabled') === 'true'
            ) {
                return;
            }

            const termId = Number(
                addAllButton.dataset.termId || this.activeInspirationTermId || 0
            );

            if (termId > 0) {
                addInspirationAllToCart(this, termId);
            }

            return;
        }

        if (this.sortRoot?.contains(event.target)) {
            return;
        }

        if (event.target.closest('[data-listing-desktop-filter]')) {
            return;
        }

        this.closeSortMenu();
        this.closeDesktopFilterMenus();
    },

    toggleDesktopFilterMenu(toggle) {
        const root = toggle.closest('[data-listing-desktop-filter]');
        const menu = root?.querySelector('[data-listing-desktop-filter-menu]');
        const icon = root?.querySelector('[data-listing-desktop-filter-icon]');

        if (!menu) {
            return;
        }

        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
            toggle.setAttribute('aria-expanded', 'false');
            menu.classList.add('hidden');
            icon?.classList.remove('rotate-180');
            return;
        }

        this.closeDesktopFilterMenus(root);

        if (!this.filterCountsLoaded) {
            this.loadFilterTermCounts();
        }

        toggle.setAttribute('aria-expanded', 'true');
        menu.classList.remove('hidden');
        icon?.classList.add('rotate-180');
    },

    closeDesktopFilterMenus(exceptRoot = null) {
        this.root
            ?.querySelectorAll('[data-listing-desktop-filter]')
            .forEach(root => {
                if (exceptRoot && root === exceptRoot) {
                    return;
                }

                const toggle = root.querySelector(
                    '[data-listing-desktop-filter-toggle]'
                );
                const menu = root.querySelector(
                    '[data-listing-desktop-filter-menu]'
                );
                const icon = root.querySelector(
                    '[data-listing-desktop-filter-icon]'
                );

                toggle?.setAttribute('aria-expanded', 'false');
                menu?.classList.add('hidden');
                icon?.classList.remove('rotate-180');
            });
    },

    onPopState(event) {
        const nextState = event.state?.listingState;

        if (!nextState) {
            window.location.reload();
            return;
        }

        this.state = { ...nextState };
        this.fetchAndRender({ pushUrl: null });
    },

    onWindowResize() {
        // Inspiracje nie używają karuzeli termów.
    },
};
